var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5V9C4.477 9 0 13.477 0 19C0 19.273 0.0100002 19.543 0.0319996 19.81C1.495 17.036 4.362 15.119 7.687 15.005L8 15H10V19.5L18 12L10 4.5ZM16 4.5V7.237L21.08 12L16.001 16.761L16 19.5L24 12L16 4.5Z",
    fill: "#B9B8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.04292db1d12ac5ee84f9e045f03d1250.svg";
export { ForwardRef as ReactComponent };